export default "__VITE_ASSET__vhQjFp_l__"